import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import moment from 'moment-timezone';
/**
 * Widget set + key order for IDG Meeting v3 documents (review-complete dialog,
 * v2→v3 regenerate). Matches legacy `idgPrintConfig` layout (Measures first with
 * IDG title) plus v3 Manifest / CompletedForms — not the dashboard
 * "IDG Components" admin preconfig.
 */

const idgDocumentWidgetSelection = {
  Measures: {
    view: 'IDG'
  },
  ClearScripts: {
    view: 'All',
    notesMode: 'dateRange'
  },
  CarePlanProblems: {
    view: 'Listing',
    notesMode: 'dateRange'
  },
  CarePlanFrequency: {
    view: 'IDG',
    notesMode: 'dateRange'
  },
  CompletedForms: {
    view: 'IDG',
    notesMode: 'dateRange'
  },
  Manifest: {
    view: 'IDG',
    filter: 'idgOnly'
  },
  // Review Complete now loads stored idgComponents via config-service.
  ProgressNotes: {
    view: 'IDG'
  }
};
export const buildIdgDocumentPreconfig = dates => {
  var _dates$fromDate, _dates$toDate;

  return _objectSpread(_objectSpread({}, idgDocumentWidgetSelection), {}, {
    fromDate: (_dates$fromDate = dates === null || dates === void 0 ? void 0 : dates.fromDate) !== null && _dates$fromDate !== void 0 ? _dates$fromDate : moment().subtract(14, 'days').format('YYYY-MM-DD'),
    toDate: (_dates$toDate = dates === null || dates === void 0 ? void 0 : dates.toDate) !== null && _dates$toDate !== void 0 ? _dates$toDate : moment().format('YYYY-MM-DD')
  });
};
/** PIM agenda dates are MM/DD/YYYY; printing expects YYYY-MM-DD. */

export const idgAgendaDatesToPrintRange = (agendaStart, agendaStop) => ({
  fromDate: moment(agendaStart, 'MM/DD/YYYY').format('YYYY-MM-DD'),
  toDate: moment(agendaStop, 'MM/DD/YYYY').format('YYYY-MM-DD')
});